export default "__VITE_ASSET__CUSxrfgv__"